<template>
  <div class="py-1">
    <MenuOption
      id="disconnect"
      :title="$t('area.business-central.auth.action.disconnect')"
      @select="onDisconnectSelect">
      <template #icon>
        <IconLucideUnplug class="h-4 w-4" />
      </template>
    </MenuOption>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

/**
 * The connection card's overflow action. Only disconnecting lives here: the page re-checks the
 * connection itself on every open (see BcSettingsView's onMounted), so a manual "verify" button
 * only ever repeated what the card already states — and when the check does fail, the banner
 * offers its own "Tjek igen" right where the failure is reported.
 */
export default {
  name: 'BcConnectionMenu',

  emits: ['close'],

  props: {
    onDisconnect: { type: Function as PropType<() => void>, required: true },
  },

  methods: {
    onDisconnectSelect(): void {
      this.onDisconnect()
      this.$emit('close')
    },
  },
}
</script>
